const Cloud = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.97656 11.0996C2.1126 11.0996 0.601562 9.58857 0.601562 7.72461C0.601562 5.96693 1.94519 4.52308 3.66137 4.36414C4.01242 2.22871 5.86675 0.599609 8.10156 0.599609C10.3364 0.599609 12.1907 2.22871 12.5418 4.36414C14.2579 4.52308 15.6016 5.96693 15.6016 7.72461C15.6016 9.58857 14.0905 11.0996 12.2266 11.0996C8.93419 11.0996 6.85904 11.0996 3.97656 11.0996Z"
      stroke="#B75A06"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Cloud;
